import { createFileRoute } from "@tanstack/react-router";

import NotificationSettings from "@/user/components/settings/NotificationSettings";

export const Route = createFileRoute(
  "/_panel/_settings/settings/notifications",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <NotificationSettings />;
}
